import React from "react";

import { useNavigate, useTranslation } from "utils";

import { Icon, Typography } from "components";

import { ScenarioPrintState } from "pages/app/scenario-analysis/utils/printState";

type DownloadPrintCardProps = {
  printState?: ScenarioPrintState;
};

export const DownloadPrintCard = ({ printState }: DownloadPrintCardProps) => {
  const { t } = useTranslation("scenarioAnalysis");
  const navigate = useNavigate();

  const handleDownload = () => {
    navigate("/scenarios-pdf", { state: printState ?? null });
  };

  return (
    <div className="download-print-card">
      <Typography variant="h4" className="download-print-card-title">
        {t("nextSteps.downloadPrint.title")}
      </Typography>

      <button className="download-print-card-row" data-testid="next-steps-download-pdf-btn" onClick={handleDownload} type="button">
        <div className="download-print-card-row-icon">
          <Icon iconName="tabler/file-download" size="m" className="download-print-card-row-icon-svg" />
        </div>
        <div className="download-print-card-row-text">
          <span className="download-print-card-row-label">{t("nextSteps.downloadPrint.cta")}</span>
          <span className="download-print-card-row-sub">{t("nextSteps.downloadPrint.description")}</span>
        </div>
        <Icon iconName="tabler/chevron-right" size="s" className="download-print-card-row-chevron" />
      </button>
    </div>
  );
};
